import InputWithLabel from "app/components/FormInputs/components/InputWithLabel/InputWithLabel";
import {
  LossLimitDays,
  LossLimitKeys,
  registrationInputMaxLength,
} from "app/utils/const";
import { injectIntl, IntlShape } from "react-intl";
import { connect } from "react-redux";
type Props = {
  intl: IntlShape;
  handleChange: (id: string, value: string | number) => void;
  selectedLossLimits: string;
  lossLimitOneDay: number | null;
  lossLimitSevenDays: number | null;
  lossLimitThirtyDays: number | null;
};

const LimitAmount = ({
  intl,
  handleChange,
  selectedLossLimits,
  lossLimitOneDay,
  lossLimitSevenDays,
  lossLimitThirtyDays,
}: Props) => {
  // Function to determine the value based on selectedLossLimits
  const getLimitAmount = () => {
    switch (selectedLossLimits) {
      case LossLimitDays.ONE_DAY:
        return lossLimitOneDay || 0; // Default to 0 if null
      case LossLimitDays.SEVEN_DAYS:
        return lossLimitSevenDays || 0; // Default to 0 if null
      case LossLimitDays.THIRTY_DAYS:
        return lossLimitThirtyDays || 0; // Default to 0 if null
      default:
        return 0; // Default value if no match
    }
  };

  return (
    <div className="form-details__row limit-amount">
      <InputWithLabel
        label={intl.formatMessage({
          id: "loss-limits-limit-amount",
        })}
        inputId={LossLimitKeys.LIMIT_AMOUNT}
        value={getLimitAmount().toString()}
        onValueChange={handleChange}
        key={LossLimitKeys.LIMIT_AMOUNT}
        maxLength={registrationInputMaxLength.emailMaxLength}
        icon={""}
        placeholder={intl.formatMessage({
          id: "loss-limits-enter-amount",
        })}
        validateInput={true}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  selectedLossLimits: state.lossLimitsModel.selectedLossLimits,
  lossLimitOneDay: state.lossLimitsModel.lossLimitOneDay,
  lossLimitSevenDays: state.lossLimitsModel.lossLimitSevenDays,
  lossLimitThirtyDays: state.lossLimitsModel.lossLimitThirtyDays,
});

const mapDispatchToProps = dispatch => ({
  setSelectedLossLimits: (payload: string) =>
    dispatch.lossLimitsModel.setSelectedLossLimits(payload),
  setLossLimitOneDay: (payload: number) =>
    dispatch.lossLimitsModel.setLossLimitOneDay(payload),
  setLossLimitSevenDays: (payload: number) =>
    dispatch.lossLimitsModel.setLossLimitSevenDays(payload),
  setLossLimitThirtyDays: (payload: number) =>
    dispatch.lossLimitsModel.setLossLimitThirtyDays(payload),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(LimitAmount));
